<template>
    <div>
        <div class="white-box white-box-no-tab text-base xs:text-lg pb-28">
            <Title
                styleCodePage
                :text="$route.meta.pageTitle"
            />
            <h4 class="py-3 md:pb-3.5 md:pt-0">
                請輸入信用卡的有效月年
            </h4>

            <CreditCardTable
                :data="data"
                class="hidden lg:block"
            >
                <FormList
                    :data="data"
                    :errorMessage="errorMessage"
                />
            </CreditCardTable>
            <CreditCardList
                :data="data"
                class="lg:hidden"
            >
                <FormList
                    :data="data"
                    :errorMessage="errorMessage"
                />
            </CreditCardList>
        </div>
        <Bottombar>
            <template #right>
                <button
                    class="btn btn-accent rounded-full"
                    :disabled="!data.year || !data.month"
                    @click="goNext()"
                >
                    下一步
                </button>
            </template>
        </Bottombar>
        <Loading :isLoading="isLoading" />
    </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Title from '@/components/text/Title.vue';
import Bottombar from '@/components/layout/Bottombar.vue';
import Loading from '@/components/Loading.vue';
import CreditCardList from './List.vue';
import CreditCardTable from './Table.vue';
import FormList from './Form.vue';
import routeName from '@/router/constant.js';
import codeList from '@/json/codeList.js';
import { submitCreditCardExp } from '@/apis/aplCatlCreditCardExp';
// import _ from 'lodash';

export default {
    components: {
        Title,
        Bottombar,
        Loading,
        CreditCardTable,
        CreditCardList,
        FormList
    },
    setup() {
        const router = useRouter();
        const store = useStore();
        const isDisableButton = ref(false);
        const errorMessage = ref('');
        // const data = ref({});
        const isLoading = ref(false);

        const code = codeList.CREDIT_CARD_EXP;
        const data = computed(() => store.state.services.changeItemsResult[code] || {});

        // if (result.value) {
        //     data.value = _.cloneDeep(result.value);
        // }

        const goNext = () => {
            isLoading.value = true;
            if (!data.value.month || !data.value.year) {
                errorMessage.value = '請填寫有效年月';
                return;
            } else {
                errorMessage.value = '';
            }
            const { cardBank, cardNo, month, year } = data.value;
            submitCreditCardExp({ cardBank, cardNo, month: month, year }).then(() => {
                store.dispatch('services/setChangeItemsResult', { code, value: data.value });
                router.push({ name: routeName.CONFIRM_DATA });
            }).catch(() => {
                isLoading.value = false;
            });
        };
        return {
            data,
            isDisableButton,
            isLoading,
            errorMessage,
            goNext,
        };
    },
};
</script>
